import { render, staticRenderFns } from "./change-security-pwd.vue?vue&type=template&id=22b02e19&scoped=true"
import script from "./change-security-pwd.vue?vue&type=script&lang=js"
export * from "./change-security-pwd.vue?vue&type=script&lang=js"
import style0 from "./change-security-pwd.vue?vue&type=style&index=0&id=22b02e19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b02e19",
  null
  
)

export default component.exports